<template>
  <div id="super-admin-base" class="flex">
    <div class="flex flex-col flex-grow">
      <div
        class="sticky top-0 left-0 z-50 flex items-center flex-shrink-0 h-10 px-6 bg-slate-200"
        :style="{ width: 'calc(100vw - 0.5rem)' }"
      >
        <router-link :to="'/clients'" class="flex items-center gap-2">
          <BlIcon icon="chevron-left" class="w-4 h-4" />
          <BlTextBody2 text="Back to client" class="capitalize-first" />
        </router-link>
      </div>

      <div
        class="sticky left-0 z-50 flex items-center h-10 gap-2 px-3 border-b super-admin-tabs top-10 bg-slate-200 border-slate-400"
        :style="{ width: 'calc(100vw - 0.5rem)' }"
      >
        <router-link
          v-for="tab in tabs"
          :key="tab.target"
          :to="tab.target"
          class="relative flex items-center h-10 px-4 transition-all duration-300"
          :class="{ 'tab-actived': tab.isActive }"
        >
          <BlTextSubtitle3 v-if="tab.isActive" :text="tab.label" />
          <BlTextBody2 v-else :text="tab.label" />
        </router-link>
      </div>

      <div id="super-admin-body" class="flex">
        <CentersManagement v-if="!$route.params.tab" />
        <SharedDatabanks v-if="$route.params.tab === 'databank'" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CentersManagement from "./CentersManagement.vue";

import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlIcon from "../BlIcon.vue";
import SharedDatabanks from "./databanks/SharedDatabanks.vue";

export default {
  name: "SuperAdmin",
  components: {
    CentersManagement,
    BlTextSubtitle3,
    BlTextBody2,
    SharedDatabanks,
    BlIcon
  },
  computed: {
    ...mapGetters(["currentUser"]),
    tabs() {
      return [
        {
          target: "/super-admin",
          isActive:
            !this.$route.params.tab || this.$route.params.tab === "center",
          label: "Centers management"
        }
        // {
        //   target: "/super-admin/databank",
        //   isActive: this.$route.params.tab === "databank",
        //   label: "Shared databanks"
        // }
      ];
    }
  },
  mounted() {
    if (this.currentUser.role !== "super_admin") {
      return this.$router.push({ name: "Clients" });
    }
  }
};
</script>

<style scoped lang="scss">
.super-admin-tabs .tab-actived::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0rem;
  height: 4px;
  background: #6750a4;
  border: 1px solid #6750a4;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/superAdmin/SuperAdmin.vue